export default __webpack_public_path__ + "static/media/(36).955ccd9f.JPG";